import React from 'react'
import PropTypes from 'prop-types'
import { MapPin } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import TextInput from '../common/components/formInputs/TextInput'
import DateInput from '../common/components/formInputs/DateInput'
import FrequencyInput from '../common/components/formInputs/FrequencyInput'

const SecondStep = ({ displayStep, formValues, setFieldValue, isEditMode }) => {
  const { t } = useTranslation(['eventManagement'])

  if (!displayStep) {
    return null
  }

  return (
    <React.Fragment>
      <div className="columns">
        <TextInput
          columnSize={12}
          name="place"
          label={t('eventManagement:classFormPage.secondStep.locationLabel')}
          placeholder={t('eventManagement:classFormPage.secondStep.locationPlaceholder')}
          leftIcon={<MapPin />}
          value={formValues.place}
          setFieldValue={setFieldValue}
        />
      </div>
      <DateInput
        label={t('eventManagement:classFormPage.secondStep.dateTimeLabel')}
        timeStart={formValues.timeStart}
        timeEnd={formValues.timeEnd}
        timezone={formValues.building ? formValues.building.timezone : undefined}
        setFieldValue={setFieldValue}
      />
      <div className="columns">
        <FrequencyInput
          timeStart={formValues.timeStart}
          value={formValues.frequency}
          isEditMode={isEditMode}
          setFieldValue={setFieldValue}
        />
      </div>
    </React.Fragment>
  )
}

SecondStep.propTypes = {
  displayStep: PropTypes.bool,
  formValues: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
}

export default SecondStep
